// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--38UXO","content":"styles-module--content--21NGv","disclaimer":"styles-module--disclaimer--3Kddy"};